export type Volume = {
  number: string
  title: string
  subtitle?: string
  bullets: string[]
  flow?: string
  comparisons?: string[]
  extraLabel?: string
  extra?: string[]
  result?: string
  wide?: boolean
}

export const volumes: Volume[] = [
  {
    number: 'Volume 1',
    title: 'Pastry Foundations, Ingredients & Essential Techniques',
    bullets: [
      'Ingredient functions',
      'Measuring and weighing',
      'Mise en place',
      'Mixing methods',
      'Temperature control',
      'Baking fundamentals',
      'Basic creams',
      'Dough handling',
      'Equipment',
      'Common mistakes',
      'Instructor cues',
      'Beginner progressions',
    ],
    result:
      'Give students the technical foundation they need before moving into advanced pastry work.',
  },
  {
    number: 'Volume 2',
    title: 'Cakes, Sponges, Fillings & Layered Desserts',
    bullets: [
      'Sponge cakes',
      'Butter cakes',
      'Chiffon',
      'Genoise',
      'Fillings',
      'Mousses',
      'Creams',
      'Ganache',
      'Layering',
      'Leveling',
      'Stacking',
      'Finishing',
      'Troubleshooting',
    ],
    result:
      'Teach students how individual techniques connect to create complete professional desserts.',
  },
  {
    number: 'Volume 3',
    title: 'Tarts, Pies, Choux & Pastry Doughs',
    bullets: [
      'Shortcrust',
      'Sweet pastry',
      'Tart shells',
      'Pie dough',
      'Blind baking',
      'Pâte à choux',
      'Éclairs',
      'Profiteroles',
      'Fillings',
      'Shaping',
      'Common defects',
      'Corrections',
    ],
    flow: 'DOUGH → REST → SHAPE → FILL → BAKE → FINISH',
  },
  {
    number: 'Volume 4',
    title: 'Laminated Doughs, Croissants & Viennoiserie',
    bullets: [
      'Butter block preparation',
      'Dough and butter consistency',
      'Lock-in',
      'Rolling',
      'Single folds',
      'Double folds',
      'Chilling',
      'Croissant shaping',
      'Pain au chocolat',
      'Danish pastry',
      'Proofing',
      'Baking',
      'Honeycomb structure',
      'Troubleshooting',
    ],
    comparisons: [
      'TOO COLD · READY · TOO WARM',
      'UNDERPROOFED · READY · OVERPROOFED',
      'DENSE · CORRECTLY LAMINATED',
    ],
  },
  {
    number: 'Volume 5',
    title: 'Chocolate, Desserts, Decoration & Presentation',
    bullets: [
      'Chocolate handling',
      'Tempering principles',
      'Ganache',
      'Truffles',
      'Chocolate decoration',
      'Plated desserts',
      'Piping',
      'Glazing',
      'Fruit decoration',
      'Finishing',
      'Color',
      'Composition',
      'Presentation',
    ],
    flow: 'CREATE → ASSEMBLE → FINISH → DECORATE → PRESENT',
  },
  {
    number: 'Volume 6',
    title: '150 Ready-to-Teach Pastry Classes',
    subtitle: 'Beginner to Advanced',
    bullets: [
      '25 Foundations & Essential Skills classes',
      '30 Cakes, Sponges & Fillings classes',
      '25 Tarts, Pies, Choux & Dough classes',
      '25 Laminated Dough & Viennoiserie classes',
      '25 Chocolate, Dessert & Decoration classes',
      '20 Mixed-Skill, Advanced & Final Project classes',
    ],
    extraLabel: 'Each class can include',
    extra: [
      'Objective',
      'Level',
      'Duration',
      'Ingredients',
      'Equipment',
      'Mise en place',
      'Demonstration',
      'Student practice',
      'Instructor cues',
      'Common errors',
      'Corrections',
      'Easier variation',
      'Advanced variation',
      'Assessment',
    ],
    wide: true,
  },
]
